module.exports = __webpack_public_path__ + "static/media/campus.adf14f07.jpg";